export default {"src":"https://web.cdn.greenlight.com/2.1420.0/_next/static/media/info-icon.50ff0d3e.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};